import { ExtensionSlot, LayoutProps } from 'piral-core';
import * as React from 'react';
import { LegacyNavigationHandler } from '../infrastructure/legacy';

export const LayoutNoSidebar: React.FC<LayoutProps> = (props) => {
  return <div className="layout-wrapper">
    <LegacyNavigationHandler />
    <div className="layout layout--no-sidebar">
      <ExtensionSlot name="Cloud.Topbar" />
      <div className="layout_content">
        <main>{props.children}</main>
      </div>
    </div> 
  </div>
};
